<span id="project-list" class="text-truncate">{{ projectsCommaSeparated$ | async }}</span>
